import {
  Link,
  NavLink,
  NavLinkProps,
  Outlet,
  Route,
  RouteProps,
  Routes,
} from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import AdevalContainer from "app/adeval/adevalContainer"
import GettyContainer from "app/getty/gettyContainer"
import Grid from '@mui/material/Grid';
import MidjourneyContainer from "app/midjourney/midjourneyContainer"
import OpenaiPromptContainer from "app/openai/openaiPromptContainer"
import OpenaiTitleContainer from "app/openai/openaiTitleContainer"
import Paper from "@mui/material/Paper";
import React from "react";
import TextField from "@mui/material/TextField";
import TitleContainer from "app/title/titleContainer"
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import axios from "axios";
import { get } from "lodash";

const AppCcrm = () => {
  return (
    <Container maxWidth={false} disableGutters={false} >
      <Outlet></Outlet>
    </Container>
  );
}

const Home = () => {
  const tools = [
    { label: "Ad Evaluation", path: "/singularity/view/adeval", description: "Score CreativeAI ads against reference library" },
    { label: "Midjourney", path: "/singularity/view/midjourney", description: "AI image generation via Midjourney" },
    { label: "Getty Images", path: "/singularity/view/getty", description: "Search and download Getty Images" },
    { label: "OpenAI Prompt", path: "/singularity/view/openai/prompt", description: "GPT-4 prompt playground" },
    { label: "OpenAI Title", path: "/singularity/view/openai/title", description: "AI title generation" },
    { label: "Title Generator", path: "/singularity/view/title", description: "Content title tools" },
  ];

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>Carbon Copilot</Typography>
      <Stack spacing={2} sx={{ maxWidth: 500 }}>
        {tools.map((tool) => (
          <Button
            key={tool.path}
            component={Link}
            to={tool.path}
            variant="outlined"
            size="large"
            sx={{ justifyContent: "flex-start", textTransform: "none", px: 3, py: 2 }}
          >
            <Box>
              <Typography variant="subtitle1">{tool.label}</Typography>
              <Typography variant="caption" color="text.secondary">{tool.description}</Typography>
            </Box>
          </Button>
        ))}
      </Stack>
    </Box>
  );
}

const routes = () => {
  return (

    <Routes>
      <Route element={<AppCcrm />}>
        <Route path="/" element={<Home />} />
        <Route path="/singularity/view"  >
          <Route path="adeval" element={<AdevalContainer />} />
          <Route path="getty" element={<GettyContainer />} />
          <Route path="midjourney" element={<MidjourneyContainer />} />
          <Route path="title" element={<TitleContainer />} />
          <Route path="openai" >
            <Route path="title" element={<OpenaiTitleContainer />} />
            <Route path="prompt" element={<OpenaiPromptContainer />} />
          </Route>

        </Route>
      </Route >
    </Routes >

  )
}


export default routes;
